// React and React hooks
import React, { useState, useRef, useEffect, useCallback } from "react";

// Third-party libraries
import moment from "moment";
import { toast } from "react-toastify";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { setTimerData } from "../../../../../features/timerData/timerDataSlice.js";

// Bootstrap components
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";

// Local components
import TimeEntryPopup from "./TimeEntryLockModal.jsx";
import MyComponent from "./EllipsisComponent.jsx";
import ProjectDropdown from "../trackerComponents/ProjectDropdown.jsx";
import TagDropdownSection from "../trackerComponents/TagDropdownSection.jsx";
import ActionsDropdownWrapper from "../trackerComponents/ActionsDropdownWrapper.jsx";
import { EditTimeInputsWrapper, DisplayTimeInputsWrapper } from "../trackerComponents/TimeInputs.jsx";
import { EditDatePickerSection, DisplayDatePickerSection } from "../trackerComponents/DatePickerSection.jsx";
import { EditDurationInput, DisplayDurationInput } from "../trackerComponents/DurationInput.jsx";
import { UpdateButton } from "../trackerComponents/UpdateButton.jsx";
import { ResumeButton } from "../trackerComponents/ResumeButton.jsx";

// Local services
import {
  convertTo24HourFormatback,
  formatChange,
  convertTo24HourFormat,
  convertTo12,
  convertTo24Hour,
  validateNoAlphabets,
} from "../services/timeFormat.js";

// Local API hooks
import {
  useClientProjectDetails,
  useTagDetails,
} from "../TimerDataApi.jsx";

// Local utilities and helpers
import { groupAndSumDurations } from "../utils/cardBodyDataProcessing.js";
import {
  duplicateTimerEntry,
  deleteTimerEntry,
  updateTimerEntry,
} from "../utils/cardBodyApiHelpers.js";
import {
  getLockHours,
} from "../utils/cardBodyUiHelpers.js";
import {
  toggleProjectStatusDropdown,
  toggleProjectStatusMobileDropdown,
  toggleProjectStatusMergeDropdown,
  toggleProjectStatusMobileMergeDropdown,
  handleDropdownToggle as createHandleDropdownToggle,
  handleProjectStatusChange as createHandleProjectStatusChange,
  handleTagInputChange as createHandleTagInputChange,
  toggleGroup as createToggleGroup,
} from "../utils/cardBodyDropdownHandlers.js";
import {
  filterClientData,
  filterTagItems,
} from "../utils/cardBodyFilterHelpers.js";
import {
  createCardBodyTimeHandlers,
  formatTimeInput,
} from "../utils/cardBodyTimeHandlers.js";
import { timeShowEdit } from "../utils/cardBodyTimeDisplayHelpers.js";
import { formatTime } from "../services/trackerServices.js";
import {
  initializeEditStateFromGroup,
  formatDurationFromSeconds,
  clearTimeErrors,
} from "../utils/cardBodyStateHelpers.js";
import { isEntryUnlocked } from "../utils/cardBodyDateHelpers.js";
import { getEntryZone } from "../../../../../utils/tenantDate.js";
import {
  renderBillableIcon,
} from "../utils/cardBodyRenderHelpers.js";
import {
  createEditModeClickHandler,
  createTagDropdownToggleHandler,
  createProjectSelectHandler,
  createSprintSelectHandler,
  createTagSelectHandler,
  createActionsDropdownToggleHandler,
  createDisplaySectionClickHandler,
  createResumeButtonClickHandler,
} from "../utils/cardBodyClickHandlers.js";
import {
  CSS_CLASSES,
  PLACEHOLDERS,
  DEFAULT_VALUES,
  INLINE_STYLES,
  STATUS_OPTIONS,
  COLORS,
} from "../utils/cardBodyConstants.js";
const CardBody = ({ item, resumeTimeTracking, resumeLoading, customeTime, timeFormat, selectedUser, globalEditedId, setGlobalEditedId, refetchTimerData }) => {
  const [deleteId, setDeleteId] = useState("");
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  // Use global editedId if provided, otherwise maintain local state for backward compatibility
  const [localEditedId, setLocalEditedId] = useState(null);
  const editedId = globalEditedId !== undefined ? globalEditedId : localEditedId;
  const effectiveSetEditedId = setGlobalEditedId || setLocalEditedId;
  const [taskNameEdit, setTaskNameEdit] = useState("");
  const [dateEdit, setDateEdit] = useState(new Date());
  const [startTimeEdit, setStartTimeEdit] = useState("");
  const [startTimeTemp, setStartTimeTemp] = useState("");
  const [startTimeEdit24, setStartTimeEdit24] = useState("");
  const [endTimeEdit, setEndTimeEdit] = useState("");
  const [endTimeTemp, setEndTimeTemp] = useState("");
  const [endTimeEdit24, setEndTimeEdit24] = useState("");
  const [clientEdit, setClientEdit] = useState(null);
  const [clientIdEdit, setClientIdEdit] = useState(null);
  const [projectNameEdit, setProjectNameEdit] = useState("");
  const [projectIdEdit, setProjectIdEdit] = useState("");
  const [dateOldEdit, setDateOldEdit] = useState(null);
  const [tagIdEdit, setTagIdEdit] = useState(null);
  const [billableEdit, setBillableEdit] = useState(false);
  const [uDuration, setUDuration] = useState(null);
  const [sprintIdEdit, setSprintIdEdit] = useState("");
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [uEndTimeError, setUEndTimeError] = useState(false);
  const [uStartTimeError, setUStartTimeError] = useState(false);
  const [sprintNameEdit, setSprintNameEdit] = useState("");
  const [projectEditDropdownOpen, setProjectEditDropdownOpen] = useState(false);
  const [tagEditDropdownOpen, setTagEditDropdownOpen] = useState(false);
  const [uFormatedTime, setUFormatedTime] = useState(0);
  const [uFormatedTimeError, setUFormatedTimeError] = useState(false);
  const [isTimeInputActive, setIsTimeInputActive] = useState(false);
  const [filter, setFilter] = useState("");
  const [selectedClients, setSelectedClients] = useState(new Set());
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectStatusFilter, setProjectStatusFilter] = useState("Active");
  const [isProjectStatusDropdownOpen, setIsProjectStatusDropdownOpen] = useState(false);
  const [isProjectStatusMobileDropdownOpen, setIsProjectStatusMobileDropdownOpen] = useState(false);
  const [isProjectStatusMergeDropdownOpen, setIsProjectStatusMergeDropdownOpen] = useState(false);
  const [isProjectStatusMobileMergeDropdownOpen, setIsProjectStatusMobileMergeDropdownOpen] = useState(false);
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [duplicateLoading, setDuplicateLoading] = useState(false);
  const [tagEdit, setTagEdit] = useState(null);
  const [tagQuery, setTagQuery] = useState("");
  const datePickerRef = useRef();
  const dispatch = useDispatch();
  const [groupedData, setGroupedData] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState([]);
  const projectEditDropdownRef = useRef(null);
  const projectDropdownContentRef = useRef(null);
  const tagEditDropdownRef = useRef(null);
  const tagDropdownContentRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [clickId, setClickId] = useState(null);
  const { appSettings } = useSelector((state) => state.appSettings);
  const startInputRef = useRef(null);
  const endInputRef = useRef(null);
  const startRowInputRef = useRef(null);
  const endRowInputRef = useRef(null);
  const start12TimeInputRef = useRef(null);
  const end12TimeInputRef = useRef(null);
  const start12TimeRowInputRef = useRef(null);
  const end12TimeRowInputRef = useRef(null);
  const activedropdownRefs = useRef({});
  const projectStatusDropdownRef = useRef(null);
  const projectStatusMobileDropdownRef = useRef(null);
  const projectStatusMergeDropdownRef = useRef(null);
  const projectStatusMobileMergeDropdownRef = useRef(null);
  const toggleGroup = createToggleGroup(effectiveSetEditedId, setExpandedGroups);

  const duplicate = async (
    task,
    project_id,
    tag_id,
    client,
    clientId,
    date,
    startTime,
    dupendTime,
    duration,
    sprint_name,
    sprint_id,
    _id,
    billable
  ) => {
    // A duplicate belongs to the SAME day as the row it was copied from.
    // Deriving it from the instant instead read the day in whichever zone the
    // viewer happened to be in, so duplicating someone else's entry could file
    // the copy on a different day than the original.
    const sourceRow =
      (item?.[1] || []).find((row) => row?._id === _id) ||
      (groupedData || []).find((group) => group?._id === _id);
    await duplicateTimerEntry({
      sourceLocalDate: sourceRow?.localDate || null,
      sourceLocalZone: sourceRow?.localZone || null,
      task,
      project_id,
      tag_id,
      client,
      clientId,
      date,
      startTime,
      dupendTime,
      duration,
      sprint_id,
      _id,
      billable,
      selectedUser,
      token,
      dispatch,
      setTimerData,
      setDuplicateLoading,
      setIsUpdateLoading,
      setActiveDropdownId,
    });
  };

  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);
  const timerData = useSelector((state) => state.timerData.timerDataState);

  const { data: clientData = [] } = useClientProjectDetails(token);
  const { data: tagOptions = [] } = useTagDetails(token);

  //expandedGroups
  useEffect(() => {
    refetchTimerData();
  }, [expandedGroups, selectedUser, refetchTimerData]);

  const handleTagInputChange = createHandleTagInputChange(setTagQuery);

  const handleResetClick = async (taskId, group) => {
    await deleteTimerEntry({
      taskId,
      group,
      selectedUser,
      token,
      dispatch,
      setTimerData,
      setIsDeleteLoading,
      setDeleteId,
      setExpandedGroups,
      handleDropdownToggle: handleDropdownToggleFunc,
    });
  };

  const filteredClientData = filterClientData(clientData, filter, projectStatusFilter);

  const handleProjectStatusChange = createHandleProjectStatusChange(setProjectStatusFilter, setSelectedClients);
  const toggleProjectStatusDropdownFunc = toggleProjectStatusDropdown(setIsProjectStatusDropdownOpen);
  const toggleProjectStatusMobileDropdownFunc = toggleProjectStatusMobileDropdown(setIsProjectStatusMobileDropdownOpen);
  const toggleProjectStatusMergeDropdownFunc = toggleProjectStatusMergeDropdown(setIsProjectStatusMergeDropdownOpen);
  const toggleProjectStatusMobileMergeDropdownFunc = toggleProjectStatusMobileMergeDropdown(setIsProjectStatusMobileMergeDropdownOpen);
  const handleDropdownToggleFunc = createHandleDropdownToggle(setActiveDropdownId);

  const updateTimer = async (event) => {
    // The form was rendered in the edited entry's own zone, so the save has to
    // read the typed times back in that same zone. Falls through to the tenant
    // zone for rows written before entries carried one.
    const editedRow =
      (item?.[1] || []).find((row) => row?._id === editedId) ||
      (groupedData || []).find((group) => group?._id === editedId);
    await updateTimerEntry({
      event,
      editedId,
      entryZone: getEntryZone(editedRow),
      taskNameEdit,
      projectIdEdit,
      dateEdit,
      startTimeEdit,
      endTimeEdit,
      dateOldEdit,
      tagIdEdit,
      billableEdit,
      uDuration,
      sprintIdEdit,
      clientEdit,
      clientIdEdit,
      selectedUser,
      token,
      dispatch,
      setTimerData,
      setExpandedGroups,
      setIsUpdateLoading,
      setUEndTimeError,
      setUStartTimeError,
      effectiveSetEditedId,
      setTaskNameEdit,
      setProjectIdEdit,
      setProjectNameEdit,
      setSprintIdEdit,
      setSprintNameEdit,
      setDateEdit,
      setStartTimeEdit,
      setEndTimeEdit,
      setStartTimeEdit24,
      setEndTimeEdit24,
      setClientEdit,
      setClientIdEdit,
      setBillableEdit,
      setTagEdit,
      setTagQuery,
      refetchTimerData,
      toast,
    });
  };

  const filteredTagItems = filterTagItems(tagOptions, tagQuery);

  // Time handlers are now imported from utils
  const timeFormatChange = formatTimeInput;

  // Wrapper for timeShowEdit to provide all required parameters
  const handleTimeShowEdit = useCallback((timeSec) => {
    timeShowEdit({
      timeSec,
      dateEdit,
      startTimeEdit,
      setUDuration,
      setUFormatedTime,
      setUFormatedTimeError,
      setEndTimeEdit,
      setUStartTimeError,
      setUEndTimeError,
    });
  }, [dateEdit, startTimeEdit]);

  useEffect(() => {
    if (startTimeEdit && endTimeEdit) {
      const timeString1 = startTimeEdit.trim();
      const timeString2 = endTimeEdit.trim();
      const format = "h:mm A";
      const time1 = moment(timeString1, format).tz(global.config.getTimeZone());
      const time2 = moment(timeString2, format).tz(global.config.getTimeZone());
      const timeDifferenceInSeconds = time2.diff(time1, "seconds");

      if (timeDifferenceInSeconds > 0) {
        setUDuration(parseInt(timeDifferenceInSeconds));
        setUFormatedTime(
          `${formatTime(
            Math.floor(parseInt(timeDifferenceInSeconds) / 3600)
          )}:${formatTime(
            Math.floor(parseInt((timeDifferenceInSeconds % 3600) / 60))
          )}:${formatTime(Math.floor(parseInt(timeDifferenceInSeconds) % 60))}`
        );
        setUStartTimeError(false);
        setUEndTimeError(false);
        setUFormatedTimeError(false);
      } else {
        setUStartTimeError(true);
        setUEndTimeError(true);
      }
    }
  }, [startTimeTemp, endTimeTemp]);

  // Create time handlers
  const {
    changeStartTime,
    changeEndTime,
    changeStartTime24,
    changeEndTime24,
  } = createCardBodyTimeHandlers({
    setStartTimeEdit,
    setEndTimeEdit,
    setStartTimeTemp,
    setEndTimeTemp,
    setStartTimeEdit24,
    setEndTimeEdit24,
    setUDuration,
    setUFormatedTime,
    setUStartTimeError,
    setUEndTimeError,
    setUFormatedTimeError,
    endTimeEdit24,
    startTimeEdit24,
    startTimeEdit,
    endTimeEdit,
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        startInputRef.current &&
        !startInputRef.current.contains(event.target)
      ) {
        // Click occurred outside the input field, trigger changeStartTime24
        if (formatChange(startInputRef.current.value)) {
          changeStartTime24(startInputRef.current.value);
        } else {
          changeStartTime24(convertTo24Hour(startTimeEdit));
        }
      }
      if (endInputRef.current && !endInputRef.current.contains(event.target)) {
        if (formatChange(endInputRef.current.value)) {
          changeEndTime24(endInputRef.current.value);
        } else {
          changeEndTime24(convertTo24Hour(endTimeEdit));
        }
      }
      if (
        startRowInputRef.current &&
        !startRowInputRef.current.contains(event.target)
      ) {
        // Click occurred outside the input field, trigger changeStartTime24
        if (formatChange(startRowInputRef.current.value)) {
          changeStartTime24(startRowInputRef.current.value);
        } else {
          changeStartTime24(convertTo24Hour(startTimeEdit));
        }
      }
      if (
        endRowInputRef.current &&
        !endRowInputRef.current.contains(event.target)
      ) {
        if (formatChange(endRowInputRef.current.value)) {
          changeEndTime24(endRowInputRef.current.value);
        } else {
          changeEndTime24(convertTo24Hour(endTimeEdit));
        }
      }
      if (
        start12TimeInputRef.current &&
        !start12TimeInputRef.current.contains(event.target)
      ) {
        let formattedTime = timeFormatChange(start12TimeInputRef.current.value);
        if (formattedTime === false) {
          changeStartTime(startTimeTemp);
        } else {
          changeStartTime(start12TimeInputRef.current.value);
        }
      }
      if (
        end12TimeInputRef.current &&
        !end12TimeInputRef.current.contains(event.target)
      ) {
        let formattedTime = timeFormatChange(end12TimeInputRef.current.value);
        if (formattedTime === false) {
          changeEndTime(endTimeTemp);
        } else {
          changeEndTime(end12TimeInputRef.current.value);
        }
      }
      if (
        start12TimeRowInputRef.current &&
        !start12TimeRowInputRef.current.contains(event.target)
      ) {
        let formattedTime = timeFormatChange(
          start12TimeRowInputRef.current.value
        );
        if (formattedTime === false) {
          changeStartTime(startTimeTemp);
        } else {
          changeStartTime(start12TimeRowInputRef.current.value);
        }
      }
      if (
        end12TimeRowInputRef.current &&
        !end12TimeRowInputRef.current.contains(event.target)
      ) {
        let formattedTime = timeFormatChange(
          end12TimeRowInputRef.current.value
        );
        if (formattedTime === false) {
          changeEndTime(endTimeTemp);
        } else {
          changeEndTime(end12TimeRowInputRef.current.value);
        }
      }
    };

    document.body.addEventListener("click", handleClickOutside);

    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, [changeStartTime24, changeEndTime24, changeStartTime, changeEndTime]);

  const handleDateIconClick = () => {
    datePickerRef.current.open(); // Open the date picker programmatically
  };

  useEffect(() => {
    const updatedGroupedData = groupAndSumDurations(item[1]);
    setGroupedData(updatedGroupedData);
  }, [item, isUpdateLoading, timerData]);
  useEffect(() => {
    const refetch = async () => {
      await refetchTimerData();
    };
    refetch();
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur();
        effectiveSetEditedId(null);
        setClickId(null);
        setProjectEditDropdownOpen(false);
        setTagEditDropdownOpen(false);
        setUEndTimeError(false);
        setUStartTimeError(false);
        setUFormatedTime(false);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [timerData]);

  // Handle click outside for active dropdown menu (duplicate/delete menu)
  useEffect(() => {
    const handleClickOutsideDropdown = (event) => {
      if (!activeDropdownId) return;

      // Portaled menu lives on document.body — treat it as inside the dropdown
      if (event.target.closest?.(".dropdown-menu1")) return;

      const anchor = activedropdownRefs.current[activeDropdownId];
      // Also accept any visible twin with the same data-actions-id (mobile/desktop pair)
      const twins = document.querySelectorAll(
        `[data-actions-id="${activeDropdownId}"]`
      );
      const clickedInsideTwin = Array.from(twins).some((node) =>
        node.contains(event.target)
      );
      if (clickedInsideTwin) return;

      if (anchor && !anchor.contains(event.target)) {
        setActiveDropdownId(null);
      } else if (!anchor) {
        setActiveDropdownId(null);
      }
    };

    document.addEventListener("click", handleClickOutsideDropdown);
    return () => {
      document.removeEventListener("click", handleClickOutsideDropdown);
    };
  }, [activeDropdownId]);

  // Close project/tag dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const projectNode = projectEditDropdownRef.current;
      const projectDropdownContent = projectDropdownContentRef.current;
      const tagNode = tagEditDropdownRef.current;
      const tagDropdownContent = tagDropdownContentRef.current;

      // Check if click is outside project dropdown (both container and dropdown content)
      if (projectEditDropdownOpen) {
        const isClickInsideProjectContainer = projectNode && projectNode.contains(event.target);
        const isClickInsideDropdown = projectDropdownContent && projectDropdownContent.contains(event.target);

        if (!isClickInsideProjectContainer && !isClickInsideDropdown) {
          setProjectEditDropdownOpen(false);
          setFilter("");
          setSelectedClients(new Set());
          setSelectedProject(null);
        }
      }

      // Check if click is outside tag dropdown (both container and dropdown content)
      if (tagEditDropdownOpen) {
        const isClickInsideTagContainer = tagNode && tagNode.contains(event.target);
        const isClickInsideTagDropdown = tagDropdownContent && tagDropdownContent.contains(event.target);

        // Don't close if clicking inside the tag container or dropdown content
        if (!isClickInsideTagContainer && !isClickInsideTagDropdown) {
          setTagEditDropdownOpen(false);
        }
      }

      // Handle project status dropdowns
      const isClickInsideProjectStatusDropdown = projectStatusDropdownRef.current && projectStatusDropdownRef.current.contains(event.target);
      const isClickInsideProjectStatusMobileDropdown = projectStatusMobileDropdownRef.current && projectStatusMobileDropdownRef.current.contains(event.target);
      const isClickInsideProjectStatusMergeDropdown = projectStatusMergeDropdownRef.current && projectStatusMergeDropdownRef.current.contains(event.target);
      const isClickInsideProjectStatusMobileMergeDropdown = projectStatusMobileMergeDropdownRef.current && projectStatusMobileMergeDropdownRef.current.contains(event.target);

      if (!isClickInsideProjectStatusDropdown) {
        setIsProjectStatusDropdownOpen(false);
      }
      if (!isClickInsideProjectStatusMobileDropdown) {
        setIsProjectStatusMobileDropdownOpen(false);
      }
      if (!isClickInsideProjectStatusMergeDropdown) {
        setIsProjectStatusMergeDropdownOpen(false);
      }
      if (!isClickInsideProjectStatusMobileMergeDropdown) {
        setIsProjectStatusMobileMergeDropdownOpen(false);
      }
    };

    // Only add listener if dropdown is open
    if (projectEditDropdownOpen || tagEditDropdownOpen || isProjectStatusDropdownOpen || isProjectStatusMobileDropdownOpen || isProjectStatusMergeDropdownOpen || isProjectStatusMobileMergeDropdownOpen) {
      // Use a small timeout to ensure the refs are set after render
      // This prevents the handler from firing immediately when opening the dropdown
      const timeoutId = setTimeout(() => {
        document.addEventListener("mousedown", handleClickOutside);
      }, 10);

      return () => {
        clearTimeout(timeoutId);
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [projectEditDropdownOpen, tagEditDropdownOpen, isProjectStatusDropdownOpen, isProjectStatusMobileDropdownOpen, isProjectStatusMergeDropdownOpen, isProjectStatusMobileMergeDropdownOpen]);

  // getLockHours is now imported from utils
  // getLockHours wrapper to pass user parameter
  const getLockHoursHandler = (date, timeZone, format) => getLockHours(date, timeZone, format, user);

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  useEffect(() => {
    if (startTimeEdit && endTimeEdit) {
      const timeString1 = startTimeEdit.trim();
      const timeString2 = endTimeEdit.trim();
      const format = "h:mm A";
      const time1 = moment(timeString1, format).tz(global.config.getTimeZone());
      const time2 = moment(timeString2, format).tz(global.config.getTimeZone());
      const timeDifferenceInSeconds = time2.diff(time1, "seconds");

      if (timeDifferenceInSeconds > 0) {
        setUStartTimeError(false);
        setUEndTimeError(false);
        setUFormatedTimeError(false);
      } else {
        setUStartTimeError(true);
        setUEndTimeError(true);
      }
    }
    startTimeEdit && setStartTimeEdit24(convertTo24Hour(startTimeEdit));
    endTimeEdit && setEndTimeEdit24(convertTo24Hour(endTimeEdit));
  }, [startTimeEdit, endTimeEdit]);

  return (
    <Card.Body className="body-mg">
      {groupedData
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .map((group, groupIndex) => (
          <React.Fragment key={groupIndex}>
            <form onSubmit={updateTimer}>
              <div
                className={`timetracker-inner data-time-tracker overview-sec-timer date-${group._id} ${group._id === editedId && group.entries.length === 1 ? "editer" : ""}`}
                style={{
                  backgroundColor:
                    group._id === editedId && group.entries.length === 1
                      ? COLORS.EDITING_BACKGROUND
                      : !isEntryUnlocked(group.endTime, global.config, getLockHoursHandler)
                        ? COLORS.WHITE
                        : "",
                }}
                onClick={() => {
                  if (!isEntryUnlocked(group.endTime, global.config, getLockHoursHandler)) {
                    handleOpenPopup();
                  } else {
                    setClickId(group.entries.length === 1 ? group._id : null);
                  }
                }}
              >
                <div className="merge-tracker">
                  <div className="overview-sec-timer-inner">
                    <div className="project-name">
                      {group.entries.length > 1 && (
                        <div
                          onClick={() => toggleGroup(groupIndex)}
                          style={INLINE_STYLES.CURSOR_POINTER}
                          className="count-merge"
                        >
                          <span>{group.entries.length}</span>
                        </div>
                      )}
                      <Col
                        className={CSS_CLASSES.CURSOR}
                        onClick={createEditModeClickHandler({
                          group,
                          getLockHoursHandler,
                          globalConfig: global.config,
                          editedId,
                          effectiveSetEditedId,
                          initializeEditStateFromGroup: () => initializeEditStateFromGroup({
                            group,
                            effectiveSetEditedId,
                            setProjectEditDropdownOpen,
                            setTagEditDropdownOpen,
                            setTaskNameEdit,
                            setProjectIdEdit,
                            setProjectNameEdit,
                            setSprintNameEdit,
                            setSprintIdEdit,
                            setDateEdit,
                            setTagIdEdit,
                            setTagEdit,
                            setTagQuery,
                            setStartTimeEdit,
                            setEndTimeEdit,
                            setStartTimeTemp,
                            setEndTimeTemp,
                            setStartTimeEdit24,
                            setEndTimeEdit24,
                            setClientEdit,
                            setClientIdEdit,
                            setBillableEdit,
                            setUFormatedTime,
                            setUDuration,
                            setUStartTimeError,
                            setUEndTimeError,
                            setUFormatedTimeError,
                            globalConfig: global.config,
                          }),
                          setClickId,
                          toggleGroup,
                          groupIndex,
                          handleOpenPopup,
                          setIsTimeInputActive,
                          setProjectEditDropdownOpen,
                          setTagEditDropdownOpen,
                          setTaskNameEdit,
                          setProjectIdEdit,
                          setProjectNameEdit,
                          setSprintNameEdit,
                          setSprintIdEdit,
                          setDateEdit,
                          setTagIdEdit,
                          setTagEdit,
                          setTagQuery,
                          setStartTimeEdit,
                          setEndTimeEdit,
                          setStartTimeTemp,
                          setEndTimeTemp,
                          setStartTimeEdit24,
                          setEndTimeEdit24,
                          setClientEdit,
                          setClientIdEdit,
                          setBillableEdit,
                          setUFormatedTime,
                          setUDuration,
                          setUStartTimeError,
                          setUEndTimeError,
                          setUFormatedTimeError,
                        })}
                      >
                        {group._id === editedId && group.entries.length === 1 ? (
                          <input
                            type="text"
                            name="task"
                            value={taskNameEdit}
                            onChange={(e) => setTaskNameEdit(e.target.value)}
                            onClick={(e) => {
                              e.stopPropagation();
                              // Sync temp values with edit values to trigger duration recalculation
                              if (startTimeEdit) {
                                setStartTimeTemp(startTimeEdit);
                              }
                              if (endTimeEdit) {
                                setEndTimeTemp(endTimeEdit);
                              }
                            }}
                            placeholder={PLACEHOLDERS.REGULAR_INPUT}
                            className={`${group._id === editedId && group.entries.length === 1 ? CSS_CLASSES.INPUT_EDIT_PROJECT : `${CSS_CLASSES.INPUT_BG} ${CSS_CLASSES.INPUT_EDIT_PROJECT}`}`}
                            style={INLINE_STYLES.TEXT_ELLIPSIS}
                            autoComplete="off"
                          />
                        ) : group._id === editedId &&
                          group.entries.length > 1 ? (
                          <React.Fragment>
                            {group.task.length > 20 && (
                              <span className="tooltip-tracker testq">
                                {group.task}
                              </span>
                            )}
                            <input
                              type="text"
                              name="task"
                              value={group.task || ''}
                              placeholder={PLACEHOLDERS.REGULAR_INPUT}
                              style={INLINE_STYLES.TEXT_ELLIPSIS}
                              autoComplete="off"
                              readOnly
                            />
                          </React.Fragment>
                        ) : null}

                        {group._id !== editedId && (
                          <MyComponent
                            group={group}
                            editedId={editedId}
                          />
                        )}
                      </Col>
                    </div>

                    <ProjectDropdown
                      isEditMode={group._id === editedId && group.entries.length === 1}
                      isMergedMode={group._id === editedId && group.entries.length > 1}
                      projectNameEdit={projectNameEdit}
                      sprintNameEdit={sprintNameEdit}
                      clientEdit={clientEdit}
                      projectIdEdit={projectIdEdit}
                      projectName={group.project?.project_name}
                      sprintName={group.sprint?.sprint_name}
                      clientName={group.client}
                      projectEditDropdownOpen={projectEditDropdownOpen}
                      setProjectEditDropdownOpen={setProjectEditDropdownOpen}
                      projectStatusFilter={projectStatusFilter}
                      setProjectStatusFilter={setProjectStatusFilter}
                      filter={filter}
                      setFilter={setFilter}
                      selectedClients={selectedClients}
                      setSelectedClients={setSelectedClients}
                      selectedProject={selectedProject}
                      setSelectedProject={setSelectedProject}
                      isProjectStatusDropdownOpen={isProjectStatusDropdownOpen}
                      setIsProjectStatusDropdownOpen={setIsProjectStatusDropdownOpen}
                      projectStatusDropdownRef={projectStatusDropdownRef}
                      handleProjectStatusChange={handleProjectStatusChange}
                      setTagEditDropdownOpen={setTagEditDropdownOpen}
                      setUStartTimeError={setUStartTimeError}
                      setUEndTimeError={setUEndTimeError}
                      setUFormatedTimeError={setUFormatedTimeError}
                      setClickId={setClickId}
                      group={group}
                      user={user}
                      filteredClientData={filteredClientData}
                      setSprintIdEdit={setSprintIdEdit}
                      setSprintNameEdit={setSprintNameEdit}
                      setProjectIdEdit={setProjectIdEdit}
                      setProjectNameEdit={setProjectNameEdit}
                      setClientEdit={setClientEdit}
                      setClientIdEdit={setClientIdEdit}
                      setBillableEdit={setBillableEdit}
                      createProjectSelectHandler={createProjectSelectHandler}
                      createSprintSelectHandler={createSprintSelectHandler}
                      projectEditDropdownRef={projectEditDropdownRef}
                      projectDropdownContentRef={projectDropdownContentRef}
                      onColClick={
                        group._id === editedId && group.entries.length > 1
                          ? () => {
                            const isUnlocked = isEntryUnlocked(group.endTime, global.config, getLockHoursHandler);
                            if (isUnlocked) {
                              if (group.entries.length === 1) {
                                initializeEditStateFromGroup({
                                  group,
                                  effectiveSetEditedId,
                                  setProjectEditDropdownOpen,
                                  setTagEditDropdownOpen,
                                  setTaskNameEdit,
                                  setProjectIdEdit,
                                  setProjectNameEdit,
                                  setSprintNameEdit,
                                  setSprintIdEdit,
                                  setDateEdit,
                                  setTagIdEdit,
                                  setTagEdit,
                                  setTagQuery,
                                  setStartTimeEdit,
                                  setEndTimeEdit,
                                  setStartTimeTemp,
                                  setEndTimeTemp,
                                  setStartTimeEdit24,
                                  setEndTimeEdit24,
                                  setClientEdit,
                                  setClientIdEdit,
                                  setBillableEdit,
                                  setUFormatedTime,
                                  setUDuration,
                                  setUStartTimeError,
                                  setUEndTimeError,
                                  setUFormatedTimeError,
                                  globalConfig: global.config,
                                  useMomentFormat: true,
                                });
                              } else {
                                toggleGroup(groupIndex);
                              }
                            } else {
                              setClickId(group.entries.length === 1 ? group._id : null);
                            }
                          }
                          : group._id !== editedId
                            ? () => {
                              if (isEntryUnlocked(group.endTime, global.config, getLockHoursHandler)) {
                                if (group.entries.length === 1) {
                                  initializeEditStateFromGroup({
                                    group,
                                    effectiveSetEditedId,
                                    setProjectEditDropdownOpen,
                                    setTagEditDropdownOpen,
                                    setTaskNameEdit,
                                    setProjectIdEdit,
                                    setProjectNameEdit,
                                    setSprintNameEdit,
                                    setSprintIdEdit,
                                    setDateEdit,
                                    setTagIdEdit,
                                    setTagEdit,
                                    setTagQuery,
                                    setStartTimeEdit,
                                    setEndTimeEdit,
                                    setStartTimeTemp,
                                    setEndTimeTemp,
                                    setStartTimeEdit24,
                                    setEndTimeEdit24,
                                    setClientEdit,
                                    setClientIdEdit,
                                    setBillableEdit,
                                    setUFormatedTime,
                                    setUDuration,
                                    setUStartTimeError,
                                    setUEndTimeError,
                                    setUFormatedTimeError,
                                    globalConfig: global.config,
                                    useMomentFormat: false,
                                  });
                                } else {
                                  toggleGroup(groupIndex);
                                }
                              } else {
                                setClickId(group.entries.length === 1 ? group._id : null);
                              }
                            }
                            : undefined
                      }
                      getLockHoursHandler={getLockHoursHandler}
                      globalConfig={global.config}
                    />

                    {/* mobile view — skip ⋮ on multi-entry group outer; keep on single entries */}
                    {group.entries.length < 2 && (
                      <ActionsDropdownWrapper
                        itemId={group._id}
                        group={group}
                        activeDropdownId={activeDropdownId}
                        duplicateLoading={duplicateLoading}
                        isDeleteLoading={isDeleteLoading}
                        deleteId={deleteId}
                        createActionsDropdownToggleHandler={createActionsDropdownToggleHandler}
                        handleDropdownToggleFunc={handleDropdownToggleFunc}
                        handleResetClick={handleResetClick}
                        getLockHoursHandler={getLockHoursHandler}
                        globalConfig={global.config}
                        setClickId={setClickId}
                        activedropdownRefs={activedropdownRefs}
                        style={INLINE_STYLES.DISPLAY_NONE}
                        showTimeEntryPopup={true}
                        showTimeEntryPopupCondition={showPopup && clickId === group._id && group.entries.length > 1}
                        showPopup={showPopup}
                        clickId={clickId}
                        onDuplicate={(e) => {
                          e.stopPropagation();
                          if (!duplicateLoading) {
                            duplicate(
                              group.task,
                              group.project._id,
                              group.tag._id,
                              group.client,
                              group.project.client_name,
                              group.date,
                              group.startTime,
                              group.endTime,
                              group.totalDuration,
                              group.sprint ? group.sprint.sprint_name : null,
                              group.sprint ? group.sprint._id : null,
                              group._id,
                              group.billable
                            );
                          }
                        }}
                      />
                    )}
                    {/* mobile view */}
                  </div>

                  <div className="outer-right-sec-overview">
                    <div className="overview-sec-timer-inner-right">
                      {/* Mobile view */}
                      <ProjectDropdown
                        isEditMode={group._id === editedId && group.entries.length === 1}
                        isMergedMode={group._id === editedId && group.entries.length > 1}
                        projectNameEdit={projectNameEdit}
                        sprintNameEdit={sprintNameEdit}
                        clientEdit={clientEdit}
                        projectIdEdit={projectIdEdit}
                        projectName={group.project?.project_name}
                        sprintName={group.sprint?.sprint_name}
                        clientName={group.client}
                        projectEditDropdownOpen={projectEditDropdownOpen}
                        setProjectEditDropdownOpen={setProjectEditDropdownOpen}
                        projectStatusFilter={projectStatusFilter}
                        setProjectStatusFilter={setProjectStatusFilter}
                        filter={filter}
                        setFilter={setFilter}
                        selectedClients={selectedClients}
                        setSelectedClients={setSelectedClients}
                        selectedProject={selectedProject}
                        setSelectedProject={setSelectedProject}
                        isProjectStatusDropdownOpen={isProjectStatusMobileDropdownOpen}
                        setIsProjectStatusDropdownOpen={setIsProjectStatusMobileDropdownOpen}
                        projectStatusDropdownRef={projectStatusMobileDropdownRef}
                        handleProjectStatusChange={handleProjectStatusChange}
                        setTagEditDropdownOpen={setTagEditDropdownOpen}
                        setClickId={null}
                        group={null}
                        user={user}
                        filteredClientData={filteredClientData}
                        setSprintIdEdit={setSprintIdEdit}
                        setSprintNameEdit={setSprintNameEdit}
                        setProjectIdEdit={setProjectIdEdit}
                        setProjectNameEdit={setProjectNameEdit}
                        setClientEdit={setClientEdit}
                        setClientIdEdit={setClientIdEdit}
                        setBillableEdit={setBillableEdit}
                        createProjectSelectHandler={null}
                        createSprintSelectHandler={null}
                        projectEditDropdownRef={projectEditDropdownRef}
                        projectDropdownContentRef={projectDropdownContentRef}
                        className="project-sprint-outer-mobile"
                        onColClick={
                          group._id === editedId && group.entries.length > 1
                            ? () => {
                              if (isEntryUnlocked(group.endTime, global.config, getLockHoursHandler)) {
                                if (group.entries.length === 1) {
                                  initializeEditStateFromGroup({
                                    group,
                                    effectiveSetEditedId,
                                    setProjectEditDropdownOpen,
                                    setTagEditDropdownOpen,
                                    setTaskNameEdit,
                                    setProjectIdEdit,
                                    setProjectNameEdit,
                                    setSprintNameEdit,
                                    setSprintIdEdit,
                                    setDateEdit,
                                    setTagIdEdit,
                                    setTagEdit,
                                    setTagQuery,
                                    setStartTimeEdit,
                                    setEndTimeEdit,
                                    setStartTimeTemp,
                                    setEndTimeTemp,
                                    setStartTimeEdit24,
                                    setEndTimeEdit24,
                                    setClientEdit,
                                    setClientIdEdit,
                                    setBillableEdit,
                                    setUFormatedTime,
                                    setUDuration,
                                    setUStartTimeError,
                                    setUEndTimeError,
                                    setUFormatedTimeError,
                                    globalConfig: global.config,
                                    useMomentFormat: true,
                                  });
                                } else {
                                  toggleGroup(groupIndex);
                                }
                              } else {
                                setClickId(group.entries.length === 1 ? group._id : null);
                              }
                            }
                            : group._id !== editedId
                              ? () => {
                                if (isEntryUnlocked(group.endTime, global.config, getLockHoursHandler)) {
                                  if (group.entries.length === 1) {
                                    initializeEditStateFromGroup({
                                      group,
                                      effectiveSetEditedId,
                                      setProjectEditDropdownOpen,
                                      setTagEditDropdownOpen,
                                      setTaskNameEdit,
                                      setProjectIdEdit,
                                      setProjectNameEdit,
                                      setSprintNameEdit,
                                      setSprintIdEdit,
                                      setDateEdit,
                                      setTagIdEdit,
                                      setTagEdit,
                                      setTagQuery,
                                      setStartTimeEdit,
                                      setEndTimeEdit,
                                      setStartTimeTemp,
                                      setEndTimeTemp,
                                      setStartTimeEdit24,
                                      setEndTimeEdit24,
                                      setClientEdit,
                                      setClientIdEdit,
                                      setBillableEdit,
                                      setUFormatedTime,
                                      setUDuration,
                                      setUStartTimeError,
                                      setUEndTimeError,
                                      setUFormatedTimeError,
                                      globalConfig: global.config,
                                    });
                                  } else {
                                    toggleGroup(groupIndex);
                                  }
                                } else {
                                  setClickId(group.entries.length === 1 ? group._id : null);
                                }
                              }
                              : undefined
                        }
                        getLockHoursHandler={getLockHoursHandler}
                        globalConfig={global.config}
                      />
                      {/* end mobile */}

                      {/* tag , timer section */}
                      <div className="tag-section-mobile-section">
                        <TagDropdownSection
                          isEditMode={group._id === editedId && group.entries.length === 1}
                          isMergedMode={group._id === editedId && group.entries.length > 1}
                          tagEdit={tagEdit}
                          tagIdEdit={tagIdEdit}
                          tagQuery={tagQuery}
                          tag={group.tag}
                          tagEditDropdownOpen={tagEditDropdownOpen}
                          setTagEditDropdownOpen={setTagEditDropdownOpen}
                          setProjectEditDropdownOpen={setProjectEditDropdownOpen}
                          handleTagInputChange={handleTagInputChange}
                          createTagSelectHandler={createTagSelectHandler}
                          createTagDropdownToggleHandler={createTagDropdownToggleHandler}
                          filteredTagItems={filteredTagItems}
                          setTagEdit={setTagEdit}
                          setTagIdEdit={setTagIdEdit}
                          setTagQuery={setTagQuery}
                          tagDropdownContentRef={tagDropdownContentRef}
                          group={group}
                          className="dddd"
                          getLockHoursHandler={getLockHoursHandler}
                          globalConfig={global.config}
                          setClickId={setClickId}
                          initializeEditStateFromGroup={initializeEditStateFromGroup}
                          effectiveSetEditedId={effectiveSetEditedId}
                          setTaskNameEdit={setTaskNameEdit}
                          setProjectIdEdit={setProjectIdEdit}
                          setProjectNameEdit={setProjectNameEdit}
                          setSprintNameEdit={setSprintNameEdit}
                          setSprintIdEdit={setSprintIdEdit}
                          setDateEdit={setDateEdit}
                          setStartTimeEdit={setStartTimeEdit}
                          setEndTimeEdit={setEndTimeEdit}
                          setStartTimeTemp={setStartTimeTemp}
                          setEndTimeTemp={setEndTimeTemp}
                          setStartTimeEdit24={setStartTimeEdit24}
                          setEndTimeEdit24={setEndTimeEdit24}
                          setClientEdit={setClientEdit}
                          setClientIdEdit={setClientIdEdit}
                          setBillableEdit={setBillableEdit}
                          setUFormatedTime={setUFormatedTime}
                          setUDuration={setUDuration}
                          setUStartTimeError={setUStartTimeError}
                          setUEndTimeError={setUEndTimeError}
                          setUFormatedTimeError={setUFormatedTimeError}
                          toggleGroup={toggleGroup}
                          groupIndex={groupIndex}
                        />


                        {renderBillableIcon({
                          billable: editedId === group._id ? billableEdit : group.billable,
                          group,
                          groupIndex,
                          toggleGroup,
                          getLockHoursHandler,
                          globalConfig: global.config,
                          setClickId,
                          initializeEditStateFromGroup,
                          effectiveSetEditedId,
                          editedId,
                          setProjectEditDropdownOpen,
                          setTagEditDropdownOpen,
                          setTaskNameEdit,
                          setProjectIdEdit,
                          setProjectNameEdit,
                          setSprintNameEdit,
                          setSprintIdEdit,
                          setDateEdit,
                          setTagIdEdit,
                          setTagEdit,
                          setTagQuery,
                          setStartTimeEdit,
                          setEndTimeEdit,
                          setStartTimeTemp,
                          setEndTimeTemp,
                          setStartTimeEdit24,
                          setEndTimeEdit24,
                          setClientEdit,
                          setClientIdEdit,
                          setBillableEdit,
                          setUFormatedTime,
                          setUDuration,
                          setUStartTimeError,
                          setUEndTimeError,
                          setUFormatedTimeError,
                          handleOpenPopup,
                        })}

                        <div
                          className={`overview-sec-timer-date-time date-${group._id}`}
                          style={INLINE_STYLES.POSITION_RELATIVE}
                        >
                          <Col>
                            {group._id === editedId &&
                              group.entries.length === 1 ? (
                              <>
                                <EditTimeInputsWrapper
                                  timeFormat={timeFormat}
                                  startTimeEdit={startTimeEdit}
                                  endTimeEdit={endTimeEdit}
                                  startTimeEdit24={startTimeEdit24}
                                  endTimeEdit24={endTimeEdit24}
                                  uStartTimeError={uStartTimeError}
                                  uEndTimeError={uEndTimeError}
                                  editedId={editedId}
                                  groupId={group._id}
                                  startInputRef={startInputRef}
                                  endInputRef={endInputRef}
                                  start12TimeInputRef={start12TimeInputRef}
                                  end12TimeInputRef={end12TimeInputRef}
                                  onChangeStartTime24={(value) => {
                                    if (validateNoAlphabets(value)) {
                                      setStartTimeEdit24(value);
                                    }
                                  }}
                                  onChangeEndTime24={(value) => {
                                    if (validateNoAlphabets(value)) {
                                      setEndTimeEdit24(value);
                                    }
                                  }}
                                  onChangeStartTime={(value) => setStartTimeEdit(value)}
                                  onChangeEndTime={(value) => setEndTimeEdit(value)}
                                  onBlurStart={() => {
                                    let finalStartTime = startTimeEdit;
                                    if (timeFormat === 24) {
                                      if (!startTimeEdit) {
                                        finalStartTime = DEFAULT_VALUES.START_TIME_24;
                                        setStartTimeEdit(DEFAULT_VALUES.START_TIME_24);
                                      }
                                    } else {
                                      if (!startTimeEdit) {
                                        finalStartTime = DEFAULT_VALUES.START_TIME_12;
                                        setStartTimeEdit(DEFAULT_VALUES.START_TIME_12);
                                      }
                                    }
                                    // Sync temp value with edit value to trigger duration recalculation
                                    if (finalStartTime) {
                                      setStartTimeTemp(finalStartTime);
                                    }
                                    setIsTimeInputActive(false);
                                  }}
                                  onBlurEnd={() => {
                                    let finalEndTime = endTimeEdit;
                                    if (timeFormat === 24) {
                                      if (!endTimeEdit) {
                                        finalEndTime = DEFAULT_VALUES.END_TIME_24;
                                        setEndTimeEdit(DEFAULT_VALUES.END_TIME_24);
                                      }
                                    } else {
                                      if (!endTimeEdit) {
                                        finalEndTime = DEFAULT_VALUES.END_TIME_12;
                                        setEndTimeEdit(DEFAULT_VALUES.END_TIME_12);
                                      }
                                    }
                                    // Sync temp value with edit value to trigger duration recalculation
                                    if (finalEndTime) {
                                      setEndTimeTemp(finalEndTime);
                                    }
                                    setIsTimeInputActive(false);
                                  }}
                                  onFocus={() => setIsTimeInputActive(true)}
                                  validateNoAlphabets={validateNoAlphabets}
                                  onClick={(e) => e.stopPropagation()}
                                />

                                <EditDatePickerSection
                                  dateEdit={dateEdit}
                                  setDateEdit={setDateEdit}
                                  setDateOldEdit={setDateOldEdit}
                                  datePickerRef={datePickerRef}
                                  handleDateIconClick={handleDateIconClick}
                                  appSettings={appSettings}
                                  getLockHoursHandler={getLockHoursHandler}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </>
                            ) : (
                              <>
                                <DisplayTimeInputsWrapper
                                  timeFormat={timeFormat}
                                  startTime={group.startTime}
                                  endTime={group.endTime}
                                  zone={getEntryZone(group)}
                                  onClick={createDisplaySectionClickHandler({
                                    group,
                                    getLockHoursHandler,
                                    globalConfig: global.config,
                                    setClickId,
                                    initializeEditStateFromGroup,
                                    effectiveSetEditedId,
                                    setProjectEditDropdownOpen,
                                    setTagEditDropdownOpen,
                                    setTaskNameEdit,
                                    setProjectIdEdit,
                                    setProjectNameEdit,
                                    setSprintNameEdit,
                                    setSprintIdEdit,
                                    setDateEdit,
                                    setTagIdEdit,
                                    setTagEdit,
                                    setTagQuery,
                                    setStartTimeEdit,
                                    setEndTimeEdit,
                                    setStartTimeTemp,
                                    setEndTimeTemp,
                                    setStartTimeEdit24,
                                    setEndTimeEdit24,
                                    setClientEdit,
                                    setClientIdEdit,
                                    setBillableEdit,
                                    setUFormatedTime,
                                    setUDuration,
                                    setUStartTimeError,
                                    setUEndTimeError,
                                    setUFormatedTimeError,
                                    toggleGroup,
                                    groupIndex,
                                    handleOpenPopup,
                                    useMomentFormat: false,
                                    onAfterInitialize: () => {
                                      setUFormatedTime(formatDurationFromSeconds(group.totalDuration));
                                      setUDuration(group.totalDuration);
                                      clearTimeErrors(setUStartTimeError, setUEndTimeError, setUFormatedTimeError);
                                    },
                                  })}
                                />
                                <DisplayDatePickerSection
                                  onClick={createDisplaySectionClickHandler({
                                    group,
                                    getLockHoursHandler,
                                    globalConfig: global.config,
                                    setClickId,
                                    initializeEditStateFromGroup,
                                    effectiveSetEditedId,
                                    setProjectEditDropdownOpen,
                                    setTagEditDropdownOpen,
                                    setTaskNameEdit,
                                    setProjectIdEdit,
                                    setProjectNameEdit,
                                    setSprintNameEdit,
                                    setSprintIdEdit,
                                    setDateEdit,
                                    setTagIdEdit,
                                    setTagEdit,
                                    setTagQuery,
                                    setStartTimeEdit,
                                    setEndTimeEdit,
                                    setStartTimeTemp,
                                    setEndTimeTemp,
                                    setStartTimeEdit24,
                                    setEndTimeEdit24,
                                    setClientEdit,
                                    setClientIdEdit,
                                    setBillableEdit,
                                    setUFormatedTime,
                                    setUDuration,
                                    setUStartTimeError,
                                    setUEndTimeError,
                                    setUFormatedTimeError,
                                    toggleGroup,
                                    groupIndex,
                                    handleOpenPopup,
                                    useMomentFormat: false,
                                    onAfterInitialize: () => {
                                      setUFormatedTime(formatDurationFromSeconds(group.totalDuration));
                                      setUDuration(group.totalDuration);
                                      clearTimeErrors(setUStartTimeError, setUEndTimeError, setUFormatedTimeError);
                                    },
                                  })}
                                />
                              </>
                            )}
                          </Col>
                        </div>

                        <div className="overview-time-edit">
                          <Col>
                            <div className="overview-time-edit-inner">
                              {/* duration edit section */}
                              {group._id === editedId &&
                                group.entries.length === 1 ? (
                                <>
                                  <EditDurationInput
                                    uFormatedTime={uFormatedTime}
                                    uFormatedTimeError={uFormatedTimeError}
                                    timeShowEdit={handleTimeShowEdit}
                                  />
                                  <ResumeButton
                                    resumeLoading={resumeLoading}
                                    customeTime={customeTime}
                                    showCondition={group._id !== editedId && group.entries.length === 1}
                                    onClick={createResumeButtonClickHandler({
                                      resumeTimeTracking,
                                      resumeLoading,
                                      customeTime,
                                      group,
                                    })}
                                  />
                                </>
                              ) : group._id === editedId &&
                                group.entries.length > 1 ? (
                                <React.Fragment>
                                  <DisplayDurationInput
                                    value={formatDurationFromSeconds(group.totalDuration)}
                                    onClick={createDisplaySectionClickHandler({
                                      group,
                                      getLockHoursHandler,
                                      globalConfig: global.config,
                                      setClickId,
                                      initializeEditStateFromGroup,
                                      effectiveSetEditedId,
                                      setProjectEditDropdownOpen,
                                      setTagEditDropdownOpen,
                                      setTaskNameEdit,
                                      setProjectIdEdit,
                                      setProjectNameEdit,
                                      setSprintNameEdit,
                                      setSprintIdEdit,
                                      setDateEdit,
                                      setTagIdEdit,
                                      setTagEdit,
                                      setTagQuery,
                                      setStartTimeEdit,
                                      setEndTimeEdit,
                                      setStartTimeTemp,
                                      setEndTimeTemp,
                                      setStartTimeEdit24,
                                      setEndTimeEdit24,
                                      setClientEdit,
                                      setClientIdEdit,
                                      setBillableEdit,
                                      setUFormatedTime,
                                      setUDuration,
                                      setUStartTimeError,
                                      setUEndTimeError,
                                      setUFormatedTimeError,
                                      toggleGroup,
                                      groupIndex,
                                      handleOpenPopup,
                                      useMomentFormat: true,
                                    })}
                                  />

                                  <ResumeButton
                                    resumeLoading={resumeLoading}
                                    customeTime={customeTime}
                                    onClick={createResumeButtonClickHandler({
                                      resumeTimeTracking,
                                      resumeLoading,
                                      customeTime,
                                      group,
                                    })}
                                  />
                                </React.Fragment>
                              ) : null}

                              {/* duration edit section end */}
                              {group._id !== editedId && (
                                <>
                                  <DisplayDurationInput
                                    value={`${formatTime(
                                      Math.floor(group.totalDuration / 3600)
                                    )}:${formatTime(
                                      Math.floor(parseInt((group.totalDuration % 3600) / 60))
                                    )}:${formatTime(
                                      Math.floor(group.totalDuration % 60)
                                    )}`}
                                    onClick={createDisplaySectionClickHandler({
                                      group,
                                      getLockHoursHandler,
                                      globalConfig: global.config,
                                      setClickId,
                                      initializeEditStateFromGroup,
                                      effectiveSetEditedId,
                                      setProjectEditDropdownOpen,
                                      setTagEditDropdownOpen,
                                      setTaskNameEdit,
                                      setProjectIdEdit,
                                      setProjectNameEdit,
                                      setSprintNameEdit,
                                      setSprintIdEdit,
                                      setDateEdit,
                                      setTagIdEdit,
                                      setTagEdit,
                                      setTagQuery,
                                      setStartTimeEdit,
                                      setEndTimeEdit,
                                      setStartTimeTemp,
                                      setEndTimeTemp,
                                      setStartTimeEdit24,
                                      setEndTimeEdit24,
                                      setClientEdit,
                                      setClientIdEdit,
                                      setBillableEdit,
                                      setUFormatedTime,
                                      setUDuration,
                                      setUStartTimeError,
                                      setUEndTimeError,
                                      setUFormatedTimeError,
                                      toggleGroup,
                                      groupIndex,
                                      handleOpenPopup,
                                      useMomentFormat: false,
                                    })}
                                  />

                                  <ResumeButton
                                    resumeLoading={resumeLoading}
                                    customeTime={customeTime}
                                    onClick={createResumeButtonClickHandler({
                                      resumeTimeTracking,
                                      resumeLoading,
                                      customeTime,
                                      group,
                                    })}
                                  />
                                </>
                              )}
                            </div>

                            {group._id === editedId &&
                              group.entries.length === 1 ? (
                              <UpdateButton
                                isTimeInputActive={isTimeInputActive}
                                isUpdateLoading={isUpdateLoading}
                                uFormatedTimeError={uFormatedTimeError}
                                uEndTimeError={uEndTimeError}
                                uStartTimeError={uStartTimeError}
                              />
                            ) : null}

                            {group._id !== editedId && group.entries.length < 2 && (
                              <ActionsDropdownWrapper
                                itemId={group._id}
                                group={group}
                                activeDropdownId={activeDropdownId}
                                duplicateLoading={duplicateLoading}
                                isDeleteLoading={isDeleteLoading}
                                deleteId={deleteId}
                                createActionsDropdownToggleHandler={createActionsDropdownToggleHandler}
                                handleDropdownToggleFunc={handleDropdownToggleFunc}
                                handleResetClick={handleResetClick}
                                getLockHoursHandler={getLockHoursHandler}
                                globalConfig={global.config}
                                setClickId={setClickId}
                                activedropdownRefs={activedropdownRefs}
                                onDuplicate={(e) => {
                                  e.stopPropagation();
                                  if (!duplicateLoading) {
                                    duplicate(
                                      group.task,
                                      group.project && group.project._id,
                                      group.tag && group.tag._id,
                                      group.client,
                                      group.project && group.project.client_name,
                                      group.date,
                                      group.startTime,
                                      group.endTime,
                                      group.totalDuration,
                                      group.sprint ? group.sprint.sprint_name : null,
                                      group.sprint ? group.sprint._id : null,
                                      group._id,
                                      group.billable
                                    );
                                  }
                                }}
                              />
                            )}
                            <div>
                              {showPopup &&
                                clickId === group._id &&
                                group.entries.length === 1 && (
                                  <TimeEntryPopup
                                    onClose={() => setShowPopup(false)}
                                  />
                                )}
                            </div>
                          </Col>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {expandedGroups.includes(groupIndex) &&
                  group.entries.length > 1 &&
                  group.entries.map((row, index) => (
                    <div
                      key={row._id || index}
                      className={`merge-tracker merge-tracker-iner ${row._id === editedId ? "editer" : ""}`}
                      style={{
                        backgroundColor: row._id === editedId ? COLORS.EDITING_BACKGROUND : COLORS.WHITE,
                        padding: row._id === editedId ? INLINE_STYLES.EDITING_PADDING.padding : "",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="overview-sec-timer-inner">
                        <div className="project-name">
                          <div className="count-merge" style={INLINE_STYLES.CURSOR_POINTER} >
                            <span></span>
                          </div>
                          <Col
                            className={CSS_CLASSES.CURSOR}
                            onClick={() => {
                              if (isEntryUnlocked(row.endTime, global.config, getLockHoursHandler)) {
                                setClickId(row._id);
                                initializeEditStateFromGroup({
                                  group: row,
                                  effectiveSetEditedId,
                                  setProjectEditDropdownOpen,
                                  setTagEditDropdownOpen,
                                  setTaskNameEdit,
                                  setProjectIdEdit,
                                  setProjectNameEdit,
                                  setSprintNameEdit,
                                  setSprintIdEdit,
                                  setDateEdit,
                                  setTagIdEdit,
                                  setTagEdit,
                                  setTagQuery,
                                  setStartTimeEdit,
                                  setEndTimeEdit,
                                  setStartTimeTemp,
                                  setEndTimeTemp,
                                  setStartTimeEdit24,
                                  setEndTimeEdit24,
                                  setClientEdit,
                                  setClientIdEdit,
                                  setBillableEdit,
                                  setUFormatedTime,
                                  setUDuration,
                                  setUStartTimeError,
                                  setUEndTimeError,
                                  setUFormatedTimeError,
                                  globalConfig: global.config,
                                  useMomentFormat: false,
                                });
                              } else {
                                handleOpenPopup();
                                setClickId(row._id);
                              }
                            }}
                          >
                            {row._id === editedId && (
                              <input
                                type="text"
                                name="task"
                                value={taskNameEdit}
                                onChange={(e) =>
                                  setTaskNameEdit(e.target.value)
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setClickId(row._id);
                                  // Sync temp values with edit values to trigger duration recalculation
                                  if (startTimeEdit) {
                                    setStartTimeTemp(startTimeEdit);
                                  }
                                  if (endTimeEdit) {
                                    setEndTimeTemp(endTimeEdit);
                                  }
                                }}
                                placeholder={PLACEHOLDERS.REGULAR_INPUT}
                                className={`${row._id === editedId ? CSS_CLASSES.INPUT_EDIT_PROJECT : `${CSS_CLASSES.INPUT_BG} ${CSS_CLASSES.INPUT_EDIT_PROJECT}`}`}
                                style={INLINE_STYLES.TEXT_ELLIPSIS}
                                autoComplete="off"
                              />
                            )}

                            {row._id !== editedId && (
                              <MyComponent
                                group={row}
                                editedId={editedId}
                              />
                            )}
                          </Col>
                        </div>

                        <ProjectDropdown
                          isEditMode={row._id === editedId}
                          isRowMode={true}
                          projectNameEdit={projectNameEdit}
                          sprintNameEdit={sprintNameEdit}
                          clientEdit={clientEdit}
                          projectIdEdit={projectIdEdit}
                          projectName={row.project?.project_name}
                          sprintName={row.sprint && row.sprint.sprint_name}
                          clientName={row.client && row.client}
                          projectEditDropdownOpen={projectEditDropdownOpen}
                          setProjectEditDropdownOpen={setProjectEditDropdownOpen}
                          projectStatusFilter={projectStatusFilter}
                          setProjectStatusFilter={setProjectStatusFilter}
                          filter={filter}
                          setFilter={setFilter}
                          selectedClients={selectedClients}
                          setSelectedClients={setSelectedClients}
                          selectedProject={selectedProject}
                          setSelectedProject={setSelectedProject}
                          isProjectStatusMergeDropdownOpen={isProjectStatusMergeDropdownOpen}
                          setIsProjectStatusMergeDropdownOpen={setIsProjectStatusMergeDropdownOpen}
                          projectStatusMergeDropdownRef={projectStatusMergeDropdownRef}
                          handleProjectStatusChange={handleProjectStatusChange}
                          setTagEditDropdownOpen={setTagEditDropdownOpen}
                          setClickId={setClickId}
                          row={row}
                          user={user}
                          filteredClientData={filteredClientData}
                          setSprintIdEdit={setSprintIdEdit}
                          setSprintNameEdit={setSprintNameEdit}
                          setProjectIdEdit={setProjectIdEdit}
                          setProjectNameEdit={setProjectNameEdit}
                          setClientEdit={setClientEdit}
                          setClientIdEdit={setClientIdEdit}
                          setBillableEdit={setBillableEdit}
                          projectEditDropdownRef={projectEditDropdownRef}
                          projectDropdownContentRef={projectDropdownContentRef}
                          className=""
                          onColClickWithEvent={(e) => {
                            if (projectDropdownContentRef.current && projectDropdownContentRef.current.contains(e.target)) {
                              return;
                            }
                            if (isEntryUnlocked(row.endTime, global.config, getLockHoursHandler)) {
                              setProjectEditDropdownOpen(!projectEditDropdownOpen);
                              setProjectStatusFilter(STATUS_OPTIONS.ACTIVE);
                              setFilter("");
                              setSelectedClients(new Set());
                              setSelectedProject(null);
                              setTagEditDropdownOpen(false);
                            }
                          }}
                          onColClick={
                            row._id !== editedId
                              ? () => {
                                if (isEntryUnlocked(row.endTime, global.config, getLockHoursHandler)) {
                                  initializeEditStateFromGroup({
                                    group: row,
                                    effectiveSetEditedId,
                                    setProjectEditDropdownOpen,
                                    setTagEditDropdownOpen,
                                    setTaskNameEdit,
                                    setProjectIdEdit,
                                    setProjectNameEdit,
                                    setSprintNameEdit,
                                    setSprintIdEdit,
                                    setDateEdit,
                                    setTagIdEdit,
                                    setTagEdit,
                                    setTagQuery,
                                    setStartTimeEdit,
                                    setEndTimeEdit,
                                    setStartTimeTemp,
                                    setEndTimeTemp,
                                    setStartTimeEdit24,
                                    setEndTimeEdit24,
                                    setClientEdit,
                                    setClientIdEdit,
                                    setBillableEdit,
                                    setUFormatedTime,
                                    setUDuration,
                                    setUStartTimeError,
                                    setUEndTimeError,
                                    setUFormatedTimeError,
                                    globalConfig: global.config,
                                  });
                                } else {
                                  handleOpenPopup();
                                  setClickId(row._id);
                                }
                              }
                              : undefined
                          }
                          getLockHoursHandler={getLockHoursHandler}
                          globalConfig={global.config}
                        />

                        {/* mobile view */}
                        <ActionsDropdownWrapper
                          itemId={row._id}
                          row={row}
                          group={group}
                          activeDropdownId={activeDropdownId}
                          duplicateLoading={duplicateLoading}
                          isDeleteLoading={isDeleteLoading}
                          deleteId={deleteId}
                          handleDropdownToggleFunc={handleDropdownToggleFunc}
                          handleResetClick={handleResetClick}
                          getLockHoursHandler={getLockHoursHandler}
                          globalConfig={global.config}
                          setClickId={setClickId}
                          activedropdownRefs={activedropdownRefs}
                          style={INLINE_STYLES.DISPLAY_NONE}
                          showTimeEntryPopup={true}
                          showTimeEntryPopupCondition={showPopup && clickId === row._id}
                          showPopup={showPopup}
                          clickId={clickId}
                          onToggleClick={() => {
                            if (isEntryUnlocked(row.endTime, global.config, getLockHoursHandler)) {
                              handleDropdownToggleFunc(row._id);
                            } else {
                              setClickId(row._id);
                            }
                          }}
                          onDuplicate={(e) => {
                            e.stopPropagation();
                            if (!duplicateLoading) {
                              duplicate(
                                row.task,
                                row.project._id,
                                row.tag._id,
                                row.client,
                                row.project.client_name,
                                row.date,
                                row.startTime,
                                row.endTime,
                                row.duration,
                                row.sprint ? row.sprint.sprint_name : null,
                                row.sprint ? row.sprint._id : null,
                                row._id,
                                row.billable
                              );
                            }
                          }}
                        />
                        {/* mobile view */}
                      </div>

                      <div className="outer-right-sec-overview">
                        <div className="overview-sec-timer-inner-right">
                          {/* Mobile view */}
                          <ProjectDropdown
                            isEditMode={row._id === editedId}
                            isRowMode={true}
                            projectNameEdit={projectNameEdit}
                            sprintNameEdit={sprintNameEdit}
                            clientEdit={clientEdit}
                            projectIdEdit={projectIdEdit}
                            projectName={row.project?.project_name}
                            sprintName={row.sprint && row.sprint.sprint_name}
                            clientName={row.client && row.client}
                            projectEditDropdownOpen={projectEditDropdownOpen}
                            setProjectEditDropdownOpen={setProjectEditDropdownOpen}
                            projectStatusFilter={projectStatusFilter}
                            setProjectStatusFilter={setProjectStatusFilter}
                            filter={filter}
                            setFilter={setFilter}
                            selectedClients={selectedClients}
                            setSelectedClients={setSelectedClients}
                            selectedProject={selectedProject}
                            setSelectedProject={setSelectedProject}
                            isProjectStatusMergeDropdownOpen={isProjectStatusMobileMergeDropdownOpen}
                            setIsProjectStatusMergeDropdownOpen={setIsProjectStatusMobileMergeDropdownOpen}
                            projectStatusMergeDropdownRef={projectStatusMobileMergeDropdownRef}
                            handleProjectStatusChange={handleProjectStatusChange}
                            setTagEditDropdownOpen={setTagEditDropdownOpen}
                            setClickId={setClickId}
                            row={row}
                            user={user}
                            filteredClientData={filteredClientData}
                            setSprintIdEdit={setSprintIdEdit}
                            setSprintNameEdit={setSprintNameEdit}
                            setProjectIdEdit={setProjectIdEdit}
                            setProjectNameEdit={setProjectNameEdit}
                            setClientEdit={setClientEdit}
                            setClientIdEdit={setClientIdEdit}
                            setBillableEdit={setBillableEdit}
                            projectEditDropdownRef={projectEditDropdownRef}
                            projectDropdownContentRef={projectDropdownContentRef}
                            className="project-sprint-outer-mobile"
                            onColClickWithEvent={(e) => {
                              if (projectDropdownContentRef.current && projectDropdownContentRef.current.contains(e.target)) {
                                return;
                              }
                              setClickId(row._id);
                              setProjectEditDropdownOpen(!projectEditDropdownOpen);
                              setProjectStatusFilter(STATUS_OPTIONS.ACTIVE);
                              setFilter("");
                              setSelectedClients(new Set());
                              setSelectedProject(null);
                              setTagEditDropdownOpen(false);
                            }}
                            onColClick={
                              row._id !== editedId
                                ? () => {
                                  if (isEntryUnlocked(row.endTime, global.config, getLockHoursHandler)) {
                                    initializeEditStateFromGroup({
                                      group: row,
                                      effectiveSetEditedId,
                                      setProjectEditDropdownOpen,
                                      setTagEditDropdownOpen,
                                      setTaskNameEdit,
                                      setProjectIdEdit,
                                      setProjectNameEdit,
                                      setSprintNameEdit,
                                      setSprintIdEdit,
                                      setDateEdit,
                                      setTagIdEdit,
                                      setTagEdit,
                                      setTagQuery,
                                      setStartTimeEdit,
                                      setEndTimeEdit,
                                      setStartTimeTemp,
                                      setEndTimeTemp,
                                      setStartTimeEdit24,
                                      setEndTimeEdit24,
                                      setClientEdit,
                                      setClientIdEdit,
                                      setBillableEdit,
                                      setUFormatedTime,
                                      setUDuration,
                                      setUStartTimeError,
                                      setUEndTimeError,
                                      setUFormatedTimeError,
                                      globalConfig: global.config,
                                    });
                                  } else {
                                    handleOpenPopup();
                                    setClickId(row._id);
                                  }
                                }
                                : undefined
                            }
                            getLockHoursHandler={getLockHoursHandler}
                            globalConfig={global.config}
                          />

                          {/* end mobile */}

                          {/* tag , timer section — same wrapper as outer card */}
                          <div className="tag-section-mobile-section">
                            <TagDropdownSection
                              isEditMode={row._id === editedId}
                              isRowMode={true}
                              tagEdit={tagEdit}
                              tagIdEdit={tagIdEdit}
                              tagQuery={tagQuery}
                              tag={row.tag}
                              tagEditDropdownOpen={tagEditDropdownOpen}
                              setTagEditDropdownOpen={setTagEditDropdownOpen}
                              setProjectEditDropdownOpen={setProjectEditDropdownOpen}
                              handleTagInputChange={handleTagInputChange}
                              createTagSelectHandler={createTagSelectHandler}
                              createTagDropdownToggleHandler={createTagDropdownToggleHandler}
                              filteredTagItems={filteredTagItems}
                              setTagEdit={setTagEdit}
                              setTagIdEdit={setTagIdEdit}
                              setTagQuery={setTagQuery}
                              tagDropdownContentRef={tagDropdownContentRef}
                              row={row}
                              getLockHoursHandler={getLockHoursHandler}
                              globalConfig={global.config}
                              setClickId={setClickId}
                              initializeEditStateFromGroup={initializeEditStateFromGroup}
                              effectiveSetEditedId={effectiveSetEditedId}
                              setTaskNameEdit={setTaskNameEdit}
                              setProjectIdEdit={setProjectIdEdit}
                              setProjectNameEdit={setProjectNameEdit}
                              setSprintNameEdit={setSprintNameEdit}
                              setSprintIdEdit={setSprintIdEdit}
                              setDateEdit={setDateEdit}
                              setStartTimeEdit={setStartTimeEdit}
                              setEndTimeEdit={setEndTimeEdit}
                              setStartTimeTemp={setStartTimeTemp}
                              setEndTimeTemp={setEndTimeTemp}
                              setStartTimeEdit24={setStartTimeEdit24}
                              setEndTimeEdit24={setEndTimeEdit24}
                              setClientEdit={setClientEdit}
                              setClientIdEdit={setClientIdEdit}
                              setBillableEdit={setBillableEdit}
                              setUFormatedTime={setUFormatedTime}
                              setUDuration={setUDuration}
                              setUStartTimeError={setUStartTimeError}
                              setUEndTimeError={setUEndTimeError}
                              setUFormatedTimeError={setUFormatedTimeError}
                              handleOpenPopup={handleOpenPopup}
                            />

                            {renderBillableIcon({
                              billable: editedId === row._id ? billableEdit : row.billable,
                              row,
                              getLockHoursHandler,
                              globalConfig: global.config,
                              setClickId,
                              initializeEditStateFromGroup,
                              effectiveSetEditedId,
                              editedId,
                              setProjectEditDropdownOpen,
                              setTagEditDropdownOpen,
                              setTaskNameEdit,
                              setProjectIdEdit,
                              setProjectNameEdit,
                              setSprintNameEdit,
                              setSprintIdEdit,
                              setDateEdit,
                              setTagIdEdit,
                              setTagEdit,
                              setTagQuery,
                              setStartTimeEdit,
                              setEndTimeEdit,
                              setStartTimeTemp,
                              setEndTimeTemp,
                              setStartTimeEdit24,
                              setEndTimeEdit24,
                              setClientEdit,
                              setClientIdEdit,
                              setBillableEdit,
                              setUFormatedTime,
                              setUDuration,
                              setUStartTimeError,
                              setUEndTimeError,
                              setUFormatedTimeError,
                              handleOpenPopup,
                            })}

                            <div
                              className={`overview-sec-timer-date-time date-${row._id}`}
                              style={INLINE_STYLES.POSITION_RELATIVE}
                            >
                              <Col>
                                {row._id === editedId ? (
                                  <>
                                    <EditTimeInputsWrapper
                                      timeFormat={timeFormat}
                                      startTimeEdit={startTimeEdit}
                                      endTimeEdit={endTimeEdit}
                                      startTimeEdit24={startTimeEdit24}
                                      endTimeEdit24={endTimeEdit24}
                                      uStartTimeError={uStartTimeError}
                                      uEndTimeError={uEndTimeError}
                                      editedId={editedId}
                                      groupId={row._id}
                                      startInputRef={startRowInputRef}
                                      endInputRef={endRowInputRef}
                                      start12TimeInputRef={start12TimeRowInputRef}
                                      end12TimeInputRef={end12TimeRowInputRef}
                                      onChangeStartTime24={(value) => {
                                        if (validateNoAlphabets(value)) {
                                          setStartTimeEdit24(value);
                                        }
                                      }}
                                      onChangeEndTime24={(value) => {
                                        if (validateNoAlphabets(value)) {
                                          setEndTimeEdit24(value);
                                        }
                                      }}
                                      onChangeStartTime={(value) => setStartTimeEdit(value)}
                                      onChangeEndTime={(value) => setEndTimeEdit(value)}
                                      onBlurStart={() => {
                                        let finalStartTime = startTimeEdit;
                                        if (timeFormat === 24) {
                                          if (!startTimeEdit) {
                                            finalStartTime = DEFAULT_VALUES.START_TIME_24;
                                            setStartTimeEdit(DEFAULT_VALUES.START_TIME_24);
                                          }
                                        } else {
                                          if (!startTimeEdit) {
                                            finalStartTime = DEFAULT_VALUES.START_TIME_12;
                                            setStartTimeEdit(DEFAULT_VALUES.START_TIME_12);
                                          }
                                        }
                                        // Sync temp value with edit value to trigger duration recalculation
                                        if (finalStartTime) {
                                          setStartTimeTemp(finalStartTime);
                                        }
                                        setIsTimeInputActive(false);
                                      }}
                                      onBlurEnd={() => {
                                        let finalEndTime = endTimeEdit;
                                        if (timeFormat === 24) {
                                          if (!endTimeEdit) {
                                            finalEndTime = DEFAULT_VALUES.END_TIME_24;
                                            setEndTimeEdit(DEFAULT_VALUES.END_TIME_24);
                                          }
                                        } else {
                                          if (!endTimeEdit) {
                                            finalEndTime = DEFAULT_VALUES.END_TIME_12;
                                            setEndTimeEdit(DEFAULT_VALUES.END_TIME_12);
                                          }
                                        }
                                        // Sync temp value with edit value to trigger duration recalculation
                                        if (finalEndTime) {
                                          setEndTimeTemp(finalEndTime);
                                        }
                                        setIsTimeInputActive(false);
                                      }}
                                      onFocus={() => setIsTimeInputActive(true)}
                                      validateNoAlphabets={validateNoAlphabets}
                                    />

                                    <EditDatePickerSection
                                      dateEdit={dateEdit}
                                      setDateEdit={setDateEdit}
                                      setDateOldEdit={setDateOldEdit}
                                      datePickerRef={datePickerRef}
                                      handleDateIconClick={handleDateIconClick}
                                      appSettings={appSettings}
                                      getLockHoursHandler={getLockHoursHandler}
                                    />
                                  </>
                                ) : (
                                  <>
                                    <DisplayTimeInputsWrapper
                                      timeFormat={timeFormat}
                                      startTime={row.startTime}
                                      endTime={row.endTime}
                                      zone={getEntryZone(row)}
                                      onClick={createDisplaySectionClickHandler({
                                        row,
                                        getLockHoursHandler,
                                        globalConfig: global.config,
                                        setClickId,
                                        initializeEditStateFromGroup,
                                        effectiveSetEditedId,
                                        setProjectEditDropdownOpen,
                                        setTagEditDropdownOpen,
                                        setTaskNameEdit,
                                        setProjectIdEdit,
                                        setProjectNameEdit,
                                        setSprintNameEdit,
                                        setSprintIdEdit,
                                        setDateEdit,
                                        setTagIdEdit,
                                        setTagEdit,
                                        setTagQuery,
                                        setStartTimeEdit,
                                        setEndTimeEdit,
                                        setStartTimeTemp,
                                        setEndTimeTemp,
                                        setStartTimeEdit24,
                                        setEndTimeEdit24,
                                        setClientEdit,
                                        setClientIdEdit,
                                        setBillableEdit,
                                        setUFormatedTime,
                                        setUDuration,
                                        setUStartTimeError,
                                        setUEndTimeError,
                                        setUFormatedTimeError,
                                        handleOpenPopup,
                                      })}
                                    />
                                    <DisplayDatePickerSection
                                      onClick={createDisplaySectionClickHandler({
                                        row,
                                        getLockHoursHandler,
                                        globalConfig: global.config,
                                        setClickId,
                                        initializeEditStateFromGroup,
                                        effectiveSetEditedId,
                                        setProjectEditDropdownOpen,
                                        setTagEditDropdownOpen,
                                        setTaskNameEdit,
                                        setProjectIdEdit,
                                        setProjectNameEdit,
                                        setSprintNameEdit,
                                        setSprintIdEdit,
                                        setDateEdit,
                                        setTagIdEdit,
                                        setTagEdit,
                                        setTagQuery,
                                        setStartTimeEdit,
                                        setEndTimeEdit,
                                        setStartTimeTemp,
                                        setEndTimeTemp,
                                        setStartTimeEdit24,
                                        setEndTimeEdit24,
                                        setClientEdit,
                                        setClientIdEdit,
                                        setBillableEdit,
                                        setUFormatedTime,
                                        setUDuration,
                                        setUStartTimeError,
                                        setUEndTimeError,
                                        setUFormatedTimeError,
                                        handleOpenPopup,
                                      })}
                                    />
                                  </>
                                )}
                              </Col>
                            </div>

                            <div className="overview-time-edit">
                              <Col>
                                <div className="overview-time-edit-inner">
                                  {/* duration edit section */}
                                  {row._id === editedId && (
                                    <EditDurationInput
                                      uFormatedTime={uFormatedTime}
                                      uFormatedTimeError={uFormatedTimeError}
                                      timeShowEdit={handleTimeShowEdit}
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  )}

                                  {/* duration edit section end */}

                                  {row._id !== editedId && (
                                    <>
                                      <DisplayDurationInput
                                        value={`${formatTime(row.hr)}:${formatTime(row.min)}:${formatTime(row.sec)}`}
                                        onClick={createDisplaySectionClickHandler({
                                          row,
                                          getLockHoursHandler,
                                          globalConfig: global.config,
                                          setClickId,
                                          initializeEditStateFromGroup,
                                          effectiveSetEditedId,
                                          setProjectEditDropdownOpen,
                                          setTagEditDropdownOpen,
                                          setTaskNameEdit,
                                          setProjectIdEdit,
                                          setProjectNameEdit,
                                          setSprintNameEdit,
                                          setSprintIdEdit,
                                          setDateEdit,
                                          setTagIdEdit,
                                          setTagEdit,
                                          setTagQuery,
                                          setStartTimeEdit,
                                          setEndTimeEdit,
                                          setStartTimeTemp,
                                          setEndTimeTemp,
                                          setStartTimeEdit24,
                                          setEndTimeEdit24,
                                          setClientEdit,
                                          setClientIdEdit,
                                          setBillableEdit,
                                          setUFormatedTime,
                                          setUDuration,
                                          setUStartTimeError,
                                          setUEndTimeError,
                                          setUFormatedTimeError,
                                          handleOpenPopup,
                                        })}
                                      />

                                      <ResumeButton
                                        resumeLoading={resumeLoading}
                                        customeTime={customeTime}
                                        onClick={createResumeButtonClickHandler({
                                          resumeTimeTracking,
                                          resumeLoading,
                                          customeTime,
                                          row,
                                        })}
                                      />
                                    </>
                                  )}
                                </div>

                                {row._id === editedId && (
                                  <UpdateButton
                                    isTimeInputActive={isTimeInputActive}
                                    isUpdateLoading={isUpdateLoading}
                                    uFormatedTimeError={uFormatedTimeError}
                                    uEndTimeError={uEndTimeError}
                                    uStartTimeError={uStartTimeError}
                                  />
                                )}

                                {row._id !== editedId && (
                                  <ActionsDropdownWrapper
                                    itemId={row._id}
                                    row={row}
                                    group={group}
                                    activeDropdownId={activeDropdownId}
                                    duplicateLoading={duplicateLoading}
                                    isDeleteLoading={isDeleteLoading}
                                    deleteId={deleteId}
                                    handleDropdownToggleFunc={handleDropdownToggleFunc}
                                    handleResetClick={handleResetClick}
                                    getLockHoursHandler={getLockHoursHandler}
                                    globalConfig={global.config}
                                    setClickId={setClickId}
                                    activedropdownRefs={activedropdownRefs}
                                    onToggleClick={() => {
                                      if (isEntryUnlocked(row.endTime, global.config, getLockHoursHandler)) {
                                        handleDropdownToggleFunc(row._id);
                                      } else {
                                        setClickId(row._id);
                                      }
                                    }}
                                    onDuplicate={(e) => {
                                      e.stopPropagation();
                                      if (!duplicateLoading) {
                                        duplicate(
                                          row.task,
                                          row.project?._id,
                                          row.tag && row.tag._id,
                                          row.client,
                                          row.project?.client_name,
                                          row.date,
                                          row.startTime,
                                          row.endTime,
                                          row.duration,
                                          row.sprint ? row.sprint.sprint_name : null,
                                          row.sprint ? row.sprint._id : null,
                                          row._id,
                                          row.billable
                                        );
                                      }
                                    }}
                                  />
                                )}
                                <div>
                                  {showPopup && clickId === row._id && (
                                    <TimeEntryPopup
                                      onClose={() => setShowPopup(false)}
                                    />
                                  )}
                                </div>
                              </Col>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </form>
          </React.Fragment>
        ))}
    </Card.Body>
  );
};

export default CardBody;
